module.exports = __webpack_public_path__ + "static/media/download.9c67232b.svg";